"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeLog = void 0;
const uuid_1 = require("uuid");
const writeLog = ({ message, hashId, data, }) => {
    let hash = hashId;
    if (!hash) {
        hash = (0, uuid_1.v4)();
    }
    console.log(hash, message, data);
    return hash;
};
exports.writeLog = writeLog;
//# sourceMappingURL=logs.js.map